exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-nav-top-workbench[data-v-8dde31dc]{text-align:left;background-color:#ffffff;width:100%;height:56px;padding:16px 24px;font-size:16px;color:#262626;line-height:24px;font-weight:500;box-sizing:border-box}.yxtbiz-nav-top-workbench .yxt-divider yxt-divider--vertical[data-v-8dde31dc]{margin:0 16px}\n", ""]);

